import React from 'react'

export default function Roadmap() {
	return (
		<div id="roadmap" className="roadmap-wrap">
			<div className="container-main w-container">
				<h2 className="h2">Roadmap</h2>

				<div className="roadmap-line">
					<div className="roadmap-item _2">
						<div className="color-block fill" />
						<div className="roadmap-item-wrap">
							<div className="roadmap-item-name">
								<div className="text-block-4">phase-one.</div>
							</div>
							<div className="roadmap-item-content">
								<div className="h4">
									<strong>Giveaway</strong>
								</div>
								<div className="roadmap-item-info">
									<p className="p1 light">
										5%: Whitelist Giveaway on Twitter, Facebook, Discord &amp;
										Slack. <br />
										15%: We mint 20 Metamates and airdrop them to random MMAL
										holders
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="roadmap-item">
						<div className="color-block fill" />
						<div className="roadmap-item-wrap">
							<div className="roadmap-item-name">
								<div className="text-block-4">phase-two.</div>
							</div>
							<div className="roadmap-item-content">
								<div className="h4">
									<strong>Sale</strong>
								</div>
								<div className="roadmap-item-info">
									<p className="p1 light">
										20%: Presale1 (1000 Metamates NFT) Auction begins at NYC
										Rooftop both online and with inperson guests
										<br /> 30%: Presale2 (1500 Metamates NFT) Auction begin on
										New York Yacht both online and with inperson guests <br />
										40%: Full sale Generative drop of Metamates NFTs (Online)
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="roadmap-item _2">
						<div className="color-block fill" />
						<div className="roadmap-item-wrap">
							<div className="roadmap-item-name">
								<div className="text-block-4">phase-three</div>
							</div>
							<div className="roadmap-item-content">
								<div className="h4">
									<strong>Special Ape Swag</strong>
								</div>
								<div className="roadmap-item-info">
									<p className="p1 light">
										45%: Special Ape Swag (t shirt with your Metamates Ape after
										2 months, Sunglasses after 4 months). You're going to get
										them for free! <br /> 50%: We airdrop 3 ETH to 10 random
										MMAL holders. <br /> 55%: We create a community wallet and
										fill it with 5 ETH.
										<br />
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="roadmap-item">
						<div className="color-block fill" />
						<div className="roadmap-item-wrap">
							<div className="roadmap-item-name">
								<div className="text-block-4">phase-four.</div>
							</div>
							<div className="roadmap-item-content">
								<div className="h4">
									<strong>Launch Metaverse Metamates</strong>
								</div>
								<div className="roadmap-item-info">
									<p className="p1 light">
										60%: Launch Metaverse Metamates Ape Lounge First Look Game
										Banner. <br /> 65 %: 15% Metamates Revenue to be donated to
										Ukraine war heroes and families through organized channels
										(ex: UNICEF, U.N Crisis relief, World Food Programme, Save
										the Children, Voices of Children etc) <br /> 70%: More
										Philanthropic Giveaways ran by the Community
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="roadmap-item _2">
						<div className="color-block fill" />
						<div className="roadmap-item-wrap">
							<div className="roadmap-item-name">
								<div className="text-block-4">phase-five</div>
							</div>
							<div className="roadmap-item-content">
								<div className="h4">
									<strong>
										Buy lands in the metaverse &amp; Success parties
									</strong>
								</div>
								<div className="roadmap-item-info">
									<p className="p1 light">
										80 %: Buy lands in the metaverse such as Sandbox,
										Decentraland, Cryptovoxels, Worldwde Webb Lands. <br /> 90%:
										We will start the development of the Metamates ecosystem on
										metaverse and collaborate with major game companies and Mega
										metaverse land owners. <br /> 100%: Exclusive Real-life
										parties with celebs and metaverse festivals will be held for
										community partners and MMAL holders.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
